var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9475_3348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4009 17.9153L17.9165 2.17397C16.2384 0.946185 14.2529 0.206671 12.1799 0.0373978C10.107 -0.131875 8.02761 0.275705 6.1723 1.21496C4.317 2.15421 2.75823 3.58846 1.66877 5.35871C0.579306 7.12895 0.0017145 9.16607 1.35914e-05 11.2442V42.7426C-0.00322212 44.8228 0.57135 46.8631 1.65977 48.6364C2.74819 50.4096 4.30777 51.8463 6.16489 52.7865C8.02201 53.7267 10.1038 54.1334 12.1786 53.9616C14.2533 53.7897 16.2397 53.0458 17.9165 51.8129L39.4009 36.0716C40.8264 35.0262 41.9856 33.6602 42.7846 32.084C43.5836 30.5079 44 28.7659 44 26.999C44 25.2322 43.5836 23.4902 42.7846 21.9141C41.9856 20.3379 40.8264 18.9719 39.4009 17.9265V17.9153Z",
    fill: "#8F8E93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9475_3348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyPlay);
export default __webpack_public_path__ + "static/media/grey-play.edf0cfebc972771f6c63e264845167c2.svg";
export { ForwardRef as ReactComponent };